import { merge, delay } from 'rxjs';
import { map } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { RoutingProfileAction } from '@cbridge-packages/routing-profile';
import { RouterAction } from '@cbridge-packages/routing';
import { generateRoutingProfileRoute } from '@cbridge-packages/routing-client-admin';

export const toggleViewRoutingProfileSidebarEpic: IEpic = (action$) => merge(
  action$.pipe(
    isTypeOfAndGetPayload(RoutingProfileAction.create.done),
    delay(100),
    map(({ result }) => RouterAction.replace([generateRoutingProfileRoute(result.routingProfileId)])),
  ),
  action$.pipe(
    isTypeOfAndGetPayload(RoutingProfileAction.update.done),
    map(({ params }) => RouterAction.replace([generateRoutingProfileRoute(params.id)])),
  ),
);
